<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="modal-header-container">
      <div class="title-container mb-4">
        <p class="modal-title mb-0">
          {{ edit ? 'Modifica' : 'Nuova' }} richiesta di ferie
        </p>
      </div>
      <hr />
    </div>

    <div class="modal-content">
      <form
        class="form-container permission-form"
        [class.holiday-edit-form]="edit"
        [formGroup]="holidayRequestForm">
        <div
          class="permission-steps-bar"
          *ngIf="!edit && newRequestControls.length > 0">
          <div class="permission-steps-info">
            <span class="permission-steps-text"
              >Step {{ currentStep + 1 }} di {{ totalSteps }}</span
            >
            <div class="permission-steps-dots">
              <span
                *ngFor="let dot of stepDots; trackBy: trackByNumber"
                class="permission-step-dot"
                [class.active]="dot === currentStep"></span>
            </div>
          </div>

          <div class="permission-steps-nav">
            <button
              type="button"
              class="permission-nav-btn"
              [disabled]="currentStep === 0"
              (click)="prevStep()"
              aria-label="Step precedente">
              <img
                src="assets/images/Shared/material-symbols-light_arrow-back.svg"
                alt=""
                class="permission-nav-icon" />
            </button>
            <button
              type="button"
              class="permission-nav-btn"
              [disabled]="currentStep === totalSteps - 1"
              (click)="nextStep()"
              aria-label="Step successivo">
              <img
                src="assets/images/Shared/material-symbols-light_arrow-right.svg"
                alt=""
                class="permission-nav-icon" />
            </button>
          </div>
        </div>

        <div class="permission-rows" formArrayName="dataHolidayArray">
          <ng-container
            *ngFor="
              let visibleRequest of visibleRequests;
              trackBy: trackByVisibleRequest
            ">
            <div
              [class.permission-row-card]="!edit"
              [formGroupName]="visibleRequest.index">
              <div class="permission-row-card-header" *ngIf="!edit">
                <p class="permission-row-card-title mb-0">
                  Richiesta {{ visibleRequest.index + 1 }}
                </p>
                <button
                  type="button"
                  [disabled]="newRequestControls.length === 1"
                  class="permission-delete-link"
                  (click)="deleteRequest(visibleRequest.control)">
                  <img
                    src="assets/images/Shared/delete_red.svg"
                    class="icon-delete-request" />
                  <span class="permission-delete-text">Elimina</span>
                </button>
              </div>

              <div class="holiday-edit-alert" *ngIf="edit">
                <div class="holiday-edit-alert-content">
                  <img
                    src="assets/images/Shared/info_alert_blue_24.svg"
                    alt=""
                    class="holiday-edit-alert-icon" />
                  <p class="holiday-edit-alert-text mb-0">
                    È possibile escludere i giorni di ferie già richiesti e
                    approvati. Non sarà avviata una nuova richiesta, ma verranno
                    semplicemente rimossi.
                  </p>
                </div>
              </div>

              <div
                class="holiday-edit-alert"
                *ngIf="hasBlockingConflict(visibleRequest.index)">
                <div class="holiday-edit-alert-content">
                  <img
                    src="assets/images/Shared/info_alert_blue_24.svg"
                    alt=""
                    class="holiday-edit-alert-icon" />
                  <p class="holiday-edit-alert-text mb-0">
                    {{ getExistingEventsAlertText(visibleRequest.index) }}
                  </p>
                </div>
              </div>

              <div
                class="existing-events-alert"
                *ngIf="
                  getExistingEventsForRequest(visibleRequest.index).length >
                    0 && !hasBlockingConflict(visibleRequest.index)
                ">
                <p class="existing-events-alert-title mb-0">
                  Eventi già presenti nella giornata
                </p>
                <p class="existing-events-alert-text mb-0">
                  {{ getExistingEventsAlertText(visibleRequest.index) }}
                </p>
              </div>

              <div class="holiday-row-grid">
                <div class="permission-field">
                  <label class="permission-label">Data di inizio</label>
                  <nz-date-picker
                    class="permission-picker"
                    [nzDisabled]="edit"
                    nzFormat="dd/MM/yyyy"
                    [nzPlaceHolder]="'Seleziona il giorno'"
                    formControlName="startDate"
                    (ngModelChange)="onStartDateChange(visibleRequest.index)"
                    [nzDisabledDate]="
                      disabledStartDateForIndex(visibleRequest.index)
                    "
                    [nzDefaultPickerValue]="defaultPickerDate"></nz-date-picker>
                </div>

                <div class="permission-field">
                  <label class="permission-label">Data di fine</label>
                  <nz-date-picker
                    class="permission-picker"
                    [nzDisabled]="
                      edit ||
                      hasBlockingConflict(visibleRequest.index) ||
                      !visibleRequest.control.get('startDate')?.value
                    "
                    nzFormat="dd/MM/yyyy"
                    [nzPlaceHolder]="'Seleziona il giorno'"
                    formControlName="endDate"
                    [nzDisabledDate]="
                      disabledEndDateForIndex(visibleRequest.index)
                    "
                    [nzDefaultPickerValue]="endDefaultPickerValue">
                  </nz-date-picker>
                </div>
              </div>

              <div
                class="date-exclude-container"
                *ngIf="edit && dateOptions.length > 1">
                <p class="mb-0 select-title">Escludi giorni di ferie</p>
                <nz-select
                  class="w-100"
                  nzMode="multiple"
                  [nzMaxTagCount]="4"
                  [formControl]="excludedDaysControl">
                  <nz-option
                    *ngFor="let day of dateOptions"
                    [nzValue]="day.value"
                    [nzLabel]="day.label"></nz-option>
                </nz-select>
              </div>

              <div
                class="note-container permission-note-container permission-row-note">
                <p class="m-0 p-0 text-note permission-label">Nota</p>
                <div class="permission-note-wrapper">
                  <textarea
                    class="w-100 permission-note-textarea"
                    [nzAutosize]="{ minRows: 3, maxRows: 3 }"
                    formControlName="notes"
                    [readOnly]="hasBlockingConflict(visibleRequest.index)"
                    nz-input
                    maxlength="250"
                    (input)="limitTextLength(visibleRequest.index)"
                    placeholder="Scrivi il corpo dell'email per la richiesta di permesso">
                  </textarea>
                  <span class="permission-note-counter">
                    {{ getRequestNotesLength(visibleRequest.index) }}/250
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <button
          *ngIf="!edit"
          type="button"
          class="permission-add-btn"
          (click)="addRequest()">
          <span class="permission-add-icon">+</span>
          Aggiungi richiesta
        </button>
      </form>
    </div>
    <div class="modal-footer-container">
      <button class="primary-btn-outline-new w-100" (click)="closeModal()">
        Annulla
      </button>
      <button
        class="primary-btn-new w-100"
        [disabled]="holidayRequestForm.invalid || hasBlockingConflicts"
        (click)="edit ? updateRequest() : saveHolidayRequest()">
        {{ edit ? 'Salva' : 'Invia' }}
      </button>
    </div>
  </div>
</div>
